import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = ["value"]
const _hoisted_2 = {
  disabled: "",
  value: ""
}
const _hoisted_3 = ["value"]

import InputWrapperWithIcon from "~/chat/vue/widget/form/fields/InputWrapperWithIcon.vue";
import ChatFormArrow from "~/chat/vue/widget/form/fields/ChatFormArrow.vue";
import {ISelectField} from "~/cabinet/vue/interface/form/elements/Interfaces";
import {useChatFormInput, useChatFormInputProps} from "~/chat/vue/widget/form/fields/useChatFormInput";
import {computed} from "vue";


const __default__ = {
    name: "ChatSelectInput"
}

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: {
    ...useChatFormInputProps<ISelectField>(),
    hideArrow: {type: Boolean}
},
  emits: ["update:modelValue", "continue"],
  setup(__props, { expose: __expose, emit: __emit }) {

let props = __props;

let emits = __emit;

let {exposedObject, placeholder} = useChatFormInput(props);

__expose(exposedObject);

function onInput(event: Event) {
    let value = (event.target as HTMLSelectElement).value;
    emits('update:modelValue', value);
    if (value) {
        setTimeout(() => emits("continue"), 0);
    }
}

let computedValue = computed(() => {
    let result = props.modelValue;
    if (!props.field.options.find(option => option.value == result)) {
        result = null;
    }
    return result;
});

(() => {
    if (!computedValue.value) {
        let def = props.field.options.find(value => value.default);
        if (def) {
            emits("update:modelValue", def.value);
        }
    }
})();


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(InputWrapperWithIcon, { field: _ctx.field }, {
    default: _withCtx(() => [
      _createElementVNode("select", {
        class: _normalizeClass({
                'with-icon': _ctx.field.icon,
                'with-icon-right': _ctx.required,
                'placeholder-color-when-blurred': (_unref(computedValue) == null),
                error: _ctx.error
            }),
        value: _unref(computedValue),
        onChange: onInput
      }, [
        _createElementVNode("option", _hoisted_2, _toDisplayString(_unref(placeholder)), 1),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.field.options, (item, index) => {
          return (_openBlock(), _createElementBlock("option", {
            key: index,
            value: item.value
          }, _toDisplayString(item.descr != null ? item.descr : item.value), 9, _hoisted_3))
        }), 128))
      ], 42, _hoisted_1),
      (!__props.hideArrow)
        ? (_openBlock(), _createBlock(ChatFormArrow, {
            key: 0,
            style: {"pointer-events":"none !important"}
          }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["field"]))
}
}

})